import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { bool, oneOf, string } from "prop-types";

import {
  IconWrapper,
  SquareFootageOutline,
  SquareFootageWrapper
} from "./styled";

/**
 * Static SquareFootageIcon component
 */

const SquareFootageIcon = ({
  desktopPadding,
  isWrapped,
  mobilePadding,
  strokeColor,
  width
}) => (
  <IconWrapper
    aria-hidden
    desktopPadding={desktopPadding}
    mobilePadding={mobilePadding}
  >
    <SquareFootageWrapper viewBox="0 0 12 12" width={width}>
      <SquareFootageOutline
        fill="none"
        fillRule="evenodd"
        isWrapped={isWrapped}
        strokeColor={strokeColor}
      >
        <path
          d="M3.745 11.303H.746a.247.247 0 0 1-.246-.246V.747C.5.61.611.5.746.5h3.41c.135 0 .246.111.246.246v10.31"
          strokeLinecap="square"
        />
        <path
          d="M2.8 7.401h8.257c.135 0 .246.111.246.246v3.41a.247.247 0 0 1-.246.246H2.78m.059-6.32h1.564M2.839 2.518h1.564m2.279 4.924v1.564m2.465-1.564v1.564"
          strokeLinecap="round"
        />
      </SquareFootageOutline>
    </SquareFootageWrapper>
  </IconWrapper>
);

SquareFootageIcon.propTypes = {
  /** A string with information about desktop padding styles */
  desktopPadding: string,
  /** Indicates if the SquareFootageIcon should receive color behavior from a parent */
  isWrapped: bool,
  /** A string with information about padding on mobile devices. Default is null */
  mobilePadding: string,
  /** Give the icon a stroke color (must be a color from the SE color library) */
  strokeColor: oneOf(Object.keys(colors)),
  /** Give the icon width/height (default is 12px) */
  width: string
};

SquareFootageIcon.defaultProps = {
  desktopPadding: "0 6px",
  isWrapped: false,
  mobilePadding: "",
  strokeColor: "koalaGrey",
  width: "12px"
};

export default SquareFootageIcon;
